import { render, staticRenderFns } from "./handleForm.vue?vue&type=template&id=15b0f784&scoped=true&"
import script from "./handleForm.vue?vue&type=script&lang=js&"
export * from "./handleForm.vue?vue&type=script&lang=js&"
import style0 from "./handleForm.vue?vue&type=style&index=0&id=15b0f784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b0f784",
  null
  
)

export default component.exports